// extracted by mini-css-extract-plugin
module.exports = {"Featured":"Company_Featured_Featured__p5Te4","Image":"Company_Featured_Image__JrDfY"};